import { getTranslateNsT } from '@/utils/get-translate-nst'
import { ModalWrapper, TipWrapper } from './atom'
import { Button } from 'task-eva-ui'
import { isDev } from 'project-config/utils/env'
import { getDomain } from 'project-config/utils/domain'

export function NeedUserLoginModal() {
  const commonT = getTranslateNsT('common')

  const linkToLogin = () => {
    const isFox = getDomain() === 1
    const url = isFox ? 'foxrenderfarm.com/sso/signin' : 'renderbus.com/sso'
    const loginUrl = isDev() ? `https://task-pre.${url}` : `https://task.${url}`
    window.location.href = `${loginUrl}?redirectHref=${window.location.href}`
  }

  return (
    <ModalWrapper>
      <TipWrapper>{commonT('need_user_login')}</TipWrapper>
      <Button
        onClick={() => {
          linkToLogin()
        }}
      >
        {commonT('login_btn')}
      </Button>
    </ModalWrapper>
  )
}
